// The profile's current_points is not written when points are spent (a redemption, a drawing
// entry), so it keeps the balance from before. The points summary is the balance the server
// enforces, and what the app and the embed read first.
export function withAvailablePoints(user, summary) {
  const available = summary?.available_points ?? summary?.availablePoints;
  if (!user || available == null || !Number.isFinite(Number(available))) return user;
  return { ...user, current_points: Number(available) };
}
